import { useEffect, useState, useRef } from "react"
import { PropTypes } from "prop-types"
import _ from "lodash"

import Translate from "../../Translate"
import { formattedDate } from "../../../time"

import InputNumber from "../NumberField/InputNumber"
import { breakDateIntoParts, defaultFieldOrder, fieldMax, fieldMin } from "./utils"

export const InputDatePolyfill = ({
  id,
  name,
  value,
  onBlur,
  onChange,
  fieldsOrder = defaultFieldOrder,
  ...otherProps
}) => {
  const [dateParts, setDateParts] = useState(breakDateIntoParts(value))
  const isUserInputRef = useRef(false)
  // Update internal state when value prop changes
  useEffect(() => {
    const newDateParts = breakDateIntoParts(value)
    // Only update if the value actually changed and it wasn't from user input
    if (!isUserInputRef.current) {
      setDateParts(newDateParts)
    }
  }, [value])

  const handleChange = (fieldName, e) => {
    const newDate = {
      ...dateParts,
      [fieldName]: e.target.value ? Number(e.target.value) : undefined
    }
    setDateParts(newDate)
    isUserInputRef.current = true
    onChange(name, formattedDate(newDate))
  }

  const handleBlur = () => {
    onBlur(name, formattedDate(dateParts))
  }

  useEffect(() => {
    isUserInputRef.current = false
  }, [dateParts])

  return (
    <Translate>
      {({ translate }) => (
        <div className="oj-input-date-polyfill">
          {_.map(fieldsOrder, field => (
            <InputNumber
              key={field}
              className={field}
              {...otherProps}
              min={fieldMin[field]}
              max={fieldMax[field]}
              id={`${id}-${field}`}
              name={`${name}-${field}`}
              placeholder={translate(`dateFormatPlaceholder-${field}`)}
              value={dateParts[field]}
              onChange={e => handleChange(field, e)}
              onBlur={handleBlur}
            />
          ))}
        </div>
      )}
    </Translate>
  )
}

InputDatePolyfill.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  fieldsOrder: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  onBlur: PropTypes.func,
  onChange: PropTypes.func
}

export default InputDatePolyfill
